import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { AppHeader } from '@/components/design';

export function NotFound() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppHeader />
      <div style={{ flex: 1, display: 'grid', placeItems: 'center', padding: 24 }}>
        <div style={{ textAlign: 'center', maxWidth: 420 }}>
          <div
            className="t-mono"
            style={{
              fontSize: 80,
              fontWeight: 600,
              lineHeight: 1,
              color: 'var(--accent-navy)',
              letterSpacing: '-0.04em',
              marginBottom: 16,
            }}
          >
            404
          </div>
          <div className="td-h2" style={{ marginBottom: 10 }}>
            Страница не найдена
          </div>
          <div className="t-body t-mute" style={{ marginBottom: 24, lineHeight: 1.5 }}>
            Возможно, ссылка устарела или турнир был удалён.
          </div>
          <Link to="/" className="btn btn-primary">
            <Home size={14} /> На главную
          </Link>
        </div>
      </div>
    </div>
  );
}
